import React from 'react';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';

import FilterModal from '../../vwa/components/filter-modal';
import VWALeftMenu from '../../vwa/components/vwa-left-menu';
import useTestFlags from '../../abtest/useTestFlags';
import { Helpers } from '../../core';

// Lazy load Orion components for AB test
const VWALeftMenuOrion = loadable(() =>
    Helpers.retryFunc(() => import('../../vwa/components/orion/vwa-left-menu-orion')),
);

export default ({
    filterProps,
    sortingOptions,
    selectedSortOption,
    onSort,
    expandedMobileMenu,
    setExpandedMobileMenu,
    resultsCount,
    clearFilters,
    filterCount,
    prefixControl,
    visId,
}) => {
    const { plpOrion } = useTestFlags(['plpOrion']);
    const { enabled: orionEnabled } = plpOrion || {};
    const LeftMenuComponent = orionEnabled ? VWALeftMenuOrion : VWALeftMenu;
    const isMobile = useSelector(
        state => state && state.ui && state.ui.customBreakpoints && state.ui.customBreakpoints.srp === 'mobile',
    );
    const disable = !resultsCount;
    return isMobile && !disable ? (
        <FilterModal
            isOpen={expandedMobileMenu}
            filterCount={filterCount}
            resultsCount={resultsCount}
            onModalClose={() => setExpandedMobileMenu(false)}
            clearFilters={clearFilters}
            className="hawksearch-modal"
            visId={visId}
            orionEnabled={orionEnabled}
        >
            {prefixControl && prefixControl}
            <LeftMenuComponent
                {...(filterProps || {})}
                aligned="right"
                sortValues={sortingOptions}
                sortValue={selectedSortOption}
                onSort={onSort}
                tooltipPosition="left"
                isSearch
                visId={visId}
            />
        </FilterModal>
    ) : null;
};
